import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';

const Layout: React.FC = () => {
  const { user, isLoading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Debug component - only shown in development
  const SessionDebug = () => {
    if (import.meta.env.DEV) {
      return (
        <div 
          style={{ 
            position: 'fixed', 
            bottom: 0, 
            right: 0, 
            background: '#000', 
            color: '#fff', 
            padding: '10px', 
            fontSize: '12px',
            zIndex: 9999,
            maxWidth: '300px',
            overflow: 'auto'
          }}
        >
          <div>Session Debug:</div>
          <div>User: {user ? user.email : 'null'}</div>
          <div>Loading: {isLoading.toString()}</div>
          <div>Token: {localStorage.getItem('sb-auth-token') ? 'exists' : 'none'}</div>
          <div>URL: {window.location.href}</div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="flex h-screen bg-background">
      {/* Sidebar - fixed en móvil, estático en desktop */}
      <div className="hidden lg:block w-64 flex-shrink-0">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      </div>
      
      {/* Sidebar móvil */}
      <div className="lg:hidden">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Contenido principal */}
      <div className="flex flex-col flex-1 w-0">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-x-hidden overflow-y-auto">
          <div className="container mx-auto px-6 py-8">
            <Outlet />
          </div>
        </main>
        <SessionDebug />
      </div>
    </div>
  );
};

export default Layout;